<template>
    <div class="inline-flex align-items-center relative">
        <button
            type="button"
            class="notif-bell-btn"
            :title="countLabel"
            @click="toggleOverlay">
            <i class="pi pi-bell text-xl"></i>
            <Badge
                v-if="count > 0"
                :value="count > 99 ? '99+' : count"
                severity="danger"
                class="notif-badge" />
        </button>

        <OverlayPanel ref="op" :showCloseIcon="false" style="width: 360px; max-width: 90vw;">
            <div class="flex align-items-center justify-content-between mb-2">
                <span class="font-semibold">Notificacoes</span>
                <Button
                    v-if="count > 0"
                    label="Marcar todas lidas"
                    severity="secondary"
                    size="small"
                    text
                    @click="marcarTodasLidas" />
            </div>

            <div v-if="isLoading" class="text-center py-3">
                <i class="pi pi-spin pi-spinner"></i>
            </div>

            <div v-else-if="itens.length === 0" class="text-center text-500 py-3 text-sm">
                <i class="pi pi-inbox text-2xl block mb-1 text-300"></i>
                Sem notificacoes
            </div>

            <ul v-else class="list-none m-0 p-0" style="max-height: 420px; overflow-y: auto;">
                <li
                    v-for="n in itens"
                    :key="n.id"
                    class="notif-item p-2 border-round mb-1 cursor-pointer"
                    :class="{ 'notif-item-unread': !n.lida_em }"
                    @click="abrirItem(n)">
                    <div class="flex align-items-start gap-2">
                        <i
                            class="pi pi-circle-fill text-xs mt-1"
                            :class="n.lida_em ? 'text-300' : 'text-primary'" />
                        <div class="flex-1" style="min-width: 0;">
                            <div class="font-semibold text-sm">{{ n.titulo }}</div>
                            <div class="text-xs text-600" style="white-space: normal;">{{ n.mensagem }}</div>
                            <div class="text-xs text-400 mt-1">{{ formatarData(n.created_at) }}</div>
                        </div>
                    </div>
                </li>
            </ul>
        </OverlayPanel>
    </div>
</template>

<script>
import Badge from 'primevue/badge';
import Button from 'primevue/button';
import OverlayPanel from 'primevue/overlaypanel';

import Notificacao from '@/service/notificacao.js';

export default {
    components: { Badge, Button, OverlayPanel },
    data() {
        return {
            count: 0,
            itens: [],
            isLoading: false,
            pollTimer: null,
        };
    },
    computed: {
        countLabel() {
            if (this.count === 0) return 'Sem notificacoes';
            return `${this.count} nao lidas`;
        },
    },
    mounted() {
        this.loadCount();
        this.pollTimer = setInterval(() => this.loadCount(), 60000);
    },
    beforeUnmount() {
        if (this.pollTimer) clearInterval(this.pollTimer);
    },
    methods: {
        loadCount() {
            Notificacao.naoLidasCount()
                .then(res => { this.count = res.data.count || 0; })
                .catch(() => {});
        },
        loadItens() {
            this.isLoading = true;
            Notificacao.minhas('per_page=20')
                .then(res => {
                    this.itens = res.data.data || [];
                })
                .catch(() => {})
                .finally(() => { this.isLoading = false; });
        },
        toggleOverlay(event) {
            this.$refs.op.toggle(event);
            this.loadItens();
        },
        abrirItem(n) {
            if (!n.lida_em) {
                Notificacao.marcarLida(n.id)
                    .then(() => {
                        n.lida_em = new Date().toISOString();
                        this.count = Math.max(0, this.count - 1);
                    });
            }
            if (n.link) {
                try {
                    const url = new URL(n.link, window.location.origin);
                    if (url.origin === window.location.origin) {
                        this.$refs.op.hide();
                        this.$router.push(url.pathname + url.search);
                        return;
                    }
                } catch (_) {}
                window.open(n.link, '_blank');
            }
        },
        marcarTodasLidas() {
            Notificacao.marcarTodasLidas()
                .then(() => {
                    this.itens.forEach(i => { if (!i.lida_em) i.lida_em = new Date().toISOString(); });
                    this.count = 0;
                });
        },
        formatarData(ts) {
            if (!ts) return '';
            const d = new Date(ts);
            const now = new Date();
            const diff = Math.floor((now - d) / 1000);
            if (diff < 60) return 'agora';
            if (diff < 3600) return `${Math.floor(diff/60)} min atras`;
            if (diff < 86400) return `${Math.floor(diff/3600)} h atras`;
            return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'});
        },
    },
};
</script>

<style scoped>
.notif-bell-btn {
    background: transparent;
    border: 1px solid rgba(255,255,255,0.75);
    color: #fff;
    cursor: pointer;
    padding: 6px 10px;
    border-radius: 6px;
    position: relative;
    transition: background 0.15s ease;
}
.notif-bell-btn:hover {
    background: rgba(255,255,255,0.15);
}
.notif-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    font-size: 10px !important;
    min-width: 18px !important;
    height: 18px !important;
    line-height: 18px !important;
    padding: 0 5px !important;
}
.notif-item {
    transition: background 0.12s ease;
}
.notif-item:hover {
    background: var(--surface-hover, #f6f9fc);
}
.notif-item-unread {
    background: var(--primary-50, #eff6ff);
}
.my-app-dark .notif-item:hover {
    background: rgba(255,255,255,0.08);
}
.my-app-dark .notif-item-unread {
    background: rgba(37, 99, 235, 0.2);
}
</style>
